import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faXmark } from "@fortawesome/free-solid-svg-icons";

interface ChipProps {
  label: string;
  onRemove?: () => void;
  isRoundedFull?: boolean;
  backgroundColor?: string;
  draggable?: boolean;
  dragValue?: string;
  onDragStart?: any;
  isHover?: boolean;
  isDragging?: boolean;
  onDragEnd?: () => void;
  onDragEnter?: () => void;
  dragSource?: "rows" | "columns";
}

const Chip: React.FC<ChipProps> = ({
  label,
  onRemove,
  isRoundedFull = false,
  backgroundColor,
  draggable = false,
  dragValue = "",
  onDragStart,
  isHover,
  isDragging,
  onDragEnd,
  dragSource,
  onDragEnter,
}) => {
  const handleDragStart = (e: React.DragEvent) => {
     if (!draggable) {
    e.preventDefault();
    return;
  }
    // if (!draggable) return;
    onDragStart(dragSource);
    e.dataTransfer.setData("text/plain", dragValue);
    e.dataTransfer.setData("text/source", dragSource ?? "");
    e.dataTransfer.effectAllowed = "move";
  };
  return (
    <div
      draggable={draggable}
      onDragStart={handleDragStart}
      onDragEnter={onDragEnter}
      onDragEnd={onDragEnd}
      style={{
        display: "flex",
        gap: 10,
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px 10px",
        borderRadius: isRoundedFull ? 100 : 10,
        background: isHover ? "#dfe3ff" : (backgroundColor ?? "#ededed"),
        opacity: isDragging ? 0.4 : 1,
        transform: isHover ? "scale(1.05)" : "scale(1)",
        transition: "0.15s",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {draggable && (
          <FontAwesomeIcon
            icon={faGripVertical}
            size="2x"
            style={{ cursor: "pointer", fontSize: 14, color: "gray" }}
          />
        )}

        <span style={{ fontSize: 14 }}>{label}</span>
      </div>
      {onRemove && (
        <FontAwesomeIcon
          icon={faXmark}
          size="2x"
          onClick={onRemove}
          style={{ cursor: "pointer", fontSize: 14 }}
        />
      )}
    </div>
  );
};

export default Chip;
